// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__3194d","boxTitle":"Qualiphy_boxTitle__3acXs","box":"Qualiphy_box__2Xyp_","toggleWrap":"Qualiphy_toggleWrap__3UsgL"};